import React from "react";

import { Redirect } from "react-router-dom";

import {
    Box,
    Typography
} from "@mui/material";

import { HomeState } from "./models";

import "./style.css";

import ZPlayLoader from "commons/zplay-loader";
import AdElement from "commons/ad-element";

import { ContentEnduserService } from "services/content-enduser-service";

import { Trans, } from "@lingui/macro";

import { ContentListContainer, MainContentPlayer } from "components/home";
import { LiveNowList } from "components/home/live-now-list/live-now-list";
import HomeBreaker from "components/home/home-breaker/home-breaker";

export class Home extends React.Component<{}, HomeState> {

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: false,
            content: null
        };


    }

    componentDidMount() {
        ContentEnduserService.getMainContent(this.getMainContentCallback, this.errorCallback);
    }


    getMainContentCallback = (data: any) => {
        this.setState(() => ({
            content: data,
            isLoading: true
        }));
    }

    errorCallback = (err: any) => {

        console.log(err);

        this.setState(() => ({
            isLoading: false
        }));
    }

    render() {

        let backofficeMode = process.env.REACT_APP_BACKOFFICE_MODE === "true"

        return (<>
            {backofficeMode && <Redirect to="/backoffice/choose-action" />}
            {
                this.state.isLoading && <Box>
                    {this.state.content?.id && <MainContentPlayer content={this.state.content} />}
                    <HomeBreaker
                        mainText="Il mondo MyCulture è tutto da scoprire"
                        mainTextColor="custom"
                        mainTextColorCustom="#fff"
                        backgroundColor="primary"
                        bottomTextColor="secondary"
                        buttons={[
                            {
                                color: "secondary",
                                variant: "filled",
                                text: "Esplora",
                                route: "/contents/list"
                            }
                        ]} />
                    <LiveNowList />
                    {false && <Box className={"h-title"} textAlign={"center"} sx={{ mb: 2 }}>
                        <Typography variant={"h1"}
                            sx={{
                                color: "#FFFFFF",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}>
                            <Trans id="h-catalog-title">Catalogo</Trans>
                        </Typography>
                    </Box>}
                    {process.env.REACT_APP_ADS_ENABLED === "true" && <AdElement />}
                    <ContentListContainer />
                    {process.env.REACT_APP_ADS_ENABLED === "true" && <AdElement />}
                    {process.env.REACT_APP_ADS_ENABLED === "true" && <AdElement />}
                </Box>
            }
            {!this.state.isLoading && <ZPlayLoader />}
        </>);
    }
}
